import { Context, CustomQuery } from '@vue-storefront/core';
import { ApiResult } from '../../types';
// 申请售后
export default async function orderApply(context: Context, params: CustomQuery): Promise<ApiResult> {
  const url = new URL('/mall/order/after_sales/apply', context.config.api.url);
  const { data: res } = await context.client.post(url.href, params);
  return res;
}
